export default __webpack_public_path__ + "static/media/cctv1.976bce69.jpg";